/* eslint-disable react/display-name */
/* eslint-disable no-undef */
import { OrderedMap } from "immutable";
import React from "react";
import { Icon, Popover } from "antd";
import DocumentUploadWrapper from "components/document-upload-wrapper";
import DocumentsDrawer from "components/documents-drawer";
import "styles/document-upload-wrapper.css";

const getDisclaimerValues = (tag) => {
    if(tag === "Income Docs") {
        return (
            <ul style={{ fontSize: "12px", fontWeight: 400 }}>
                <li>Limits can be reduced if Bank Statements, Financials are not available</li>
            </ul>
        );
    }
};

const getMandatoryBadge = (tag, is_mandatory, isChecklist, level, is_category, good_to_have) => {
    if(is_category) {
        return (<div
            style={{ fontSize: "12px", fontWeight: 600 }} 
            className={[1, 2, 3].includes(level) ? "mb-0" : null}
        >
            {tag}
        </div>);
    }

    if(tag === "Income Docs") {
        return (
            <div>
                <span style={{paddingRight: "2px"}}>{tag}</span>
                <Popover content={(
                    <React.Fragment>
                        <span style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                        }}>
                            Disclaimer:
                        </span><br />
                        {getDisclaimerValues(tag)}
                    </React.Fragment>
                )}>
                    <Icon type="info-circle"/>
                </Popover>
            </div>
        );
    }
    if(is_mandatory && !isChecklist) {
        return (
            <div
                style={
                    level === 1 ? { fontSize: "12px", fontWeight: 600 }
                        : [2, 3].includes(level) ? 
                            { fontWeight: 600, fontSize: "12px" } : null
                } 
                className={[1, 2, 3].includes(level) ? "mb-0" : null}
            >
                <span className="asterisk">
                    {tag}
                </span>
            </div>
        );
    } else if(good_to_have) {
        return (<div
            style={{ fontSize: "12px", fontWeight: 600 }} 
            className={[1, 2, 3].includes(level) ? "mb-0" : null}
        >
            <span className="hash">
                {tag}
            </span>
        </div>);
    } else {
        return (
            <span style={{fontSize: "12px"}}>
                {tag}
            </span>
        );
    }
};

const getValue = (val) => {
    return (
        <span style={{fontSize: "12px"}}>
            {val}
        </span>
    );
};

export default new OrderedMap({
    category: {
        key: "category",
        dataIndex: "category",
        render: (_, record) => {
            if(typeof _ === "object"){
                if (_.level === 1) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, true, _.good_to_have);
                } else if (_.level === 2) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, true, _.good_to_have);
                } else if (_.level === 3) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, true, _.good_to_have);
                } else if (_.level === 4) {
                    return getValue(_.value);
                } else if (_.level === 5) {
                    return getValue(_.value);
                } else if (_.level == "Bool") {
                    return _.value ? 
                        <Icon type="check-circle" theme="filled" style={{ color: "green" }} /> : 
                        _.type === "doc" && record.openAsTab ?
                            <DocumentUploadWrapper
                                caseId={record.caseId}
                                companyId={record.companyId}
                                fetchChecklist={record.fetchChecklist}
                                documentId={_.document_id}
                                associateId={_.associate_id}
                            /> : 
                            <Icon type="check-circle" theme="filled" style={{ color: "#cacaca" }} />;
                }
            } else if(record.is_mandatory) {
                return getMandatoryBadge(_, true, record.isChecklist);
            } else {
                return getValue(_);
            }
        },
        width: 100
    },
    col1: {
        key: "col1",
        dataIndex: "col1",
        render: (_, record) => {
            if (!_) {
                return null;
            }
            if (typeof _ === "string" || typeof _ === "number") {
                return getValue(_);
            } else if(typeof _ === "object") {
                if (_.level === 1) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, null, false, _.good_to_have);
                } else if (_.level === 2) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 3) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 4) {
                    return getValue(_.value);
                } else if (_.level === 5) {
                    return getValue(_.value);
                } else if (_.level == "Bool") {
                    return _.value ? 
                        (
                            <React.Fragment>
                                <Icon type="check-circle" theme="filled" style={{ color: "green", paddingRight: "20px" }} />
                                {_.type === "doc" && (
                                    <React.Fragment>
                                        <DocumentUploadWrapper
                                            caseId={record.caseId}
                                            companyId={record.companyId}
                                            fetchChecklist={record.fetchChecklist}
                                            documentId={_.document_id}
                                            associateId={_.associate_id}
                                        />
                                        <DocumentsDrawer
                                            urls={_.document_url}
                                        />
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        ) :
                        _.type === "doc" && record.openAsTab ?
                            <DocumentUploadWrapper
                                caseId={record.caseId}
                                companyId={record.companyId}
                                fetchChecklist={record.fetchChecklist}
                                documentId={_.document_id}
                                associateId={_.associate_id}
                            /> : 
                            <Icon type="check-circle" theme="filled" style={{ color: "#cacaca" }} />;
                }
            } else if(record.is_mandatory, record.isChecklist) {
                return getMandatoryBadge(_, true);
            }
            return getValue(_);
        },
        width: 100
    },
    col2: {
        key: "col2",
        dataIndex: "col2",
        render: (_, record) => {
            if (!_) {
                return null;
            }
            if (typeof _ === "string" || typeof _ === "number") {
                return getValue(_);
            } else if(typeof _ === "object") {
                if (_.level === 1) {
                    return getValue(_.value);
                } else if (_.level === 2) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 3) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 4) {
                    return getValue(_.value);
                } else if (_.level === 5) {
                    return getValue(_.value);
                } else if (_.level == "Bool") {
                    return _.value ? 
                        (
                            <React.Fragment>
                                <Icon type="check-circle" theme="filled" style={{ color: "green", paddingRight: "20px"}} />
                                {_.type === "doc" && (
                                    <React.Fragment>
                                        <DocumentUploadWrapper
                                            caseId={record.caseId}
                                            companyId={record.companyId}
                                            fetchChecklist={record.fetchChecklist}
                                            documentId={_.document_id}
                                            onUpload={_.on_upload}
                                            associateId={_.associate_id}
                                        />
                                        <DocumentsDrawer
                                            urls={_.document_url && _.document_url.map(_ => _.file)}
                                        />
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        ) :
                        _.type === "doc" && record.openAsTab ?
                            <DocumentUploadWrapper
                                caseId={record.caseId}
                                onUpload={_.on_upload}
                                companyId={record.companyId}
                                fetchChecklist={record.fetchChecklist}
                                documentId={_.document_id}
                                associateId={_.associate_id}
                            /> : 
                            <Icon type="check-circle" theme="filled" style={{ color: "#cacaca" }} />;
                }
            } else if(record.is_mandatory) {
                return getMandatoryBadge(_, true, record.isChecklist);
            }
            return getValue(_);
        },
        width: 100
    },
    col3: {
        key: "col3",
        dataIndex: "col3",
        render: (_, record) => {
            if (!_) {
                return null;
            }
            if (typeof _ === "string" || typeof _ === "number") {
                return getValue(_);
            } else if(typeof _ === "object") {
                if (_.level === 1) {
                    return getValue(_.value);
                } else if (_.level === 2) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 3) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 4) {
                    return getValue(_.value);
                } else if (_.level === 5) {
                    return getValue(_.value);
                } else if (_.level == "Bool") {
                    return _.value ? 
                        (
                            <React.Fragment>
                                <Icon type="check-circle" theme="filled" style={{ color: "green", paddingRight: "20px" }} />
                                {_.type === "doc" && (
                                    <React.Fragment>
                                        <DocumentUploadWrapper
                                            caseId={record.caseId}
                                            companyId={record.companyId}
                                            fetchChecklist={record.fetchChecklist}
                                            documentId={_.document_id}
                                            associateId={_.associate_id}
                                        />
                                        <DocumentsDrawer
                                            urls={_.document_url && _.document_url.map(_ => _.file)}
                                        />
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        ) :
                        _.type === "doc" && record.openAsTab ?
                            <DocumentUploadWrapper
                                caseId={record.caseId}
                                companyId={record.companyId}
                                fetchChecklist={record.fetchChecklist}
                                documentId={_.document_id}
                                associateId={_.associate_id}
                            /> : 
                            <Icon type="check-circle" theme="filled" style={{ color: "#cacaca" }} />;
                }
            } else if(record.is_mandatory) {
                return getMandatoryBadge(_, true, record.isChecklist);
            }
            return getValue(_);
        },
        width: 100
    },
    col4: {
        key: "col4",
        dataIndex: "col4",
        render: (_, record) => {
            if (!_) {
                return null;
            }
            if (typeof _ === "string" || typeof _ === "number") {
                return getValue(_);
            } else if(typeof _ === "object") {
                if (_.level === 1) {
                    return getValue(_.value);
                } else if (_.level === 2) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 3) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 4) {
                    return getValue(_.value);
                } else if (_.level === 5) {
                    return getValue(_.value);
                } else if (_.level == "Bool") {
                    return _.value ? 
                        (
                            <React.Fragment>
                                <Icon type="check-circle" theme="filled" style={{ color: "green", paddingRight: "20px" }} />
                                {_.type === "doc" && (
                                    <React.Fragment>
                                        <DocumentUploadWrapper
                                            caseId={record.caseId}
                                            companyId={record.companyId}
                                            fetchChecklist={record.fetchChecklist}
                                            documentId={_.document_id}
                                            associateId={_.associate_id}
                                        />
                                        <DocumentsDrawer
                                            urls={_.document_url && _.document_url.map(_ => _.file)}
                                        />
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        ) :
                        _.type === "doc" && record.openAsTab ?
                            <DocumentUploadWrapper
                                caseId={record.caseId}
                                companyId={record.companyId}
                                fetchChecklist={record.fetchChecklist}
                                documentId={_.document_id}
                                associateId={_.associate_id}
                            /> : 
                            <Icon type="check-circle" theme="filled" style={{ color: "#cacaca" }} />;
                }
            } else if(record.is_mandatory) {
                return getMandatoryBadge(_, true, record.isChecklist);
            }
            return getValue(_);
        },
        width: 100
    },
    col5: {
        key: "col5",
        dataIndex: "col5",
        render: (_, record) => {
            if (!_) {
                return null;
            }
            if (typeof _ === "string" || typeof _ === "number") {
                return getValue(_);
            } else if(typeof _ === "object") {
                if (_.level === 1) {
                    return getValue(_.value);
                } else if (_.level === 2) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 3) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 4) {
                    return getValue(_.value);
                } else if (_.level === 5) {
                    return getValue(_.value);
                } else if (_.level == "Bool") {
                    return _.value ? 
                        (
                            <React.Fragment>
                                <Icon type="check-circle" theme="filled" style={{ color: "green", paddingRight: "20px" }} />
                                {_.type === "doc" && (
                                    <React.Fragment>
                                        <DocumentUploadWrapper
                                            caseId={record.caseId}
                                            companyId={record.companyId}
                                            fetchChecklist={record.fetchChecklist}
                                            documentId={_.document_id}
                                            associateId={_.associate_id}
                                        />
                                        <DocumentsDrawer
                                            urls={_.document_url && _.document_url.map(_ => _.file)}
                                        />
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        ) :
                        _.type === "doc" && record.openAsTab ?
                            <DocumentUploadWrapper
                                caseId={record.caseId}
                                companyId={record.companyId}
                                fetchChecklist={record.fetchChecklist}
                                documentId={_.document_id}
                                associateId={_.associate_id}
                            /> : 
                            <Icon type="check-circle" theme="filled" style={{ color: "#cacaca" }} />;
                }
            } else if(record.is_mandatory) {
                return getMandatoryBadge(_, true, record.isChecklist);
            }
            return getValue(_);
        },
        width: 100
    },
    col6: {
        key: "col6",
        dataIndex: "col6",
        render: (_, record) => {
            if (!_) {
                return null;
            }
            if (typeof _ === "string" || typeof _ === "number") {
                return getValue(_);
            } else if(typeof _ === "object") {
                if (_.level === 1) {
                    return getValue(_.value);
                } else if (_.level === 2) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 3) {
                    return getMandatoryBadge(_.value, _.is_mandatory, record.isChecklist, _.level, false, _.good_to_have);
                } else if (_.level === 4) {
                    return getValue(_.value);
                } else if (_.level === 5) {
                    return getValue(_.value);
                } else if (_.level == "Bool") {
                    return _.value ? 
                        (
                            <React.Fragment>
                                <Icon type="check-circle" theme="filled" style={{ color: "green", paddingRight: "20px" }} />
                                {_.type === "doc" && (
                                    <React.Fragment>
                                        <DocumentUploadWrapper
                                            caseId={record.caseId}
                                            companyId={record.companyId}
                                            fetchChecklist={record.fetchChecklist}
                                            documentId={_.document_id}
                                            associateId={_.associate_id}
                                        />
                                        <DocumentsDrawer
                                            urls={_.document_url && _.document_url.map(_ => _.file)}
                                        />
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        ) :
                        _.type === "doc" && record.openAsTab ?
                            <DocumentUploadWrapper
                                caseId={record.caseId}
                                companyId={record.companyId}
                                fetchChecklist={record.fetchChecklist}
                                documentId={_.document_id}
                                associateId={_.associate_id}
                            /> : 
                            <Icon type="check-circle" theme="filled" style={{ color: "#cacaca" }} />;
                }
            } else if(record.is_mandatory) {
                return getMandatoryBadge(_, true, record.isChecklist);
            }
            return getValue(_);
        },
        width: 100
    }
});